export function validateEmail(input) {
  const validation =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (validation.test(String(input).toLowerCase())) {
    return input.indexOf("'") === -1;
  }
  return false;
}

export function validatePhone(input) {
  return /^[ \+\(\)\-0-9]+$/.test(input);
}
